import { RealmEnum }                    from '@app/modules/user/models/user.model';
import { IRouteDefinition }             from '@core/interfaces/route.interface';
import { RouteInfoOptions }             from '@core/interfaces/sidebar.interface';
import { ListOperationsIdentifierEnum } from '@shared/list-operations/model/list-operations.model';

// ENUMS #############################################################
export enum ManageTenantIdentifierEnum {
	ADMIN_CONSOLE_USER_DETAIL_PAGE_TENANT_ID_ACTION_TO_OVERVIEW = 'AdminConsole UserDetail Page TenantId Action to Overview',
	ADMIN_CONSOLE_USER_DETAIL_PAGE_USER_ID_ACTION_TO_USER_DETAILS = 'AdminConsole UserDetail Page UserId Action to User Details',
	TENANT_DETAIL_PAGE = 'Tenant Detail Page',
	TENANT_LIST_PAGE = 'Tenant List Page'
}


// INTERFACES ########################################################
interface IManageTenantBase {
	id: ManageTenantIdentifierEnum;
	tenantId: string;
	realm?: RealmEnum;
}

export interface IManageTenant extends IManageTenantBase {
	data?: object;
	navigate: {
		back: {
			listOperation?: {
				id: ListOperationsIdentifierEnum;
				shouldRestore: boolean;
			};
			route: IRouteDefinition;
		},
		to: {
			route: IRouteDefinition;
		}
	};
	routeInfoOptions?: Map<string, RouteInfoOptions>;
}


// TYPES #############################################################
export type ManageTenantType =
	| ManageTenantAdminConsoleUserDetailPageTenantIdActionToOverview
	| ManageTenantAdminConsoleUserDetailPageUserIdActionToUserDetails
	| ManageTenantTenantDetailPage
	| ManageTenantTenantListPage;


// ENTITIES ##########################################################
export class ManageTenantAdminConsoleUserDetailPageTenantIdActionToOverview implements IManageTenantBase {
	public readonly id: ManageTenantIdentifierEnum = ManageTenantIdentifierEnum.ADMIN_CONSOLE_USER_DETAIL_PAGE_TENANT_ID_ACTION_TO_OVERVIEW;

	constructor(
		public data: {
			userId: string
		},
		public realm: RealmEnum,
		public tenantId: string
	) {
		this.data = data;
		this.realm = realm;
		this.tenantId = tenantId;
	}
}

export class ManageTenantAdminConsoleUserDetailPageUserIdActionToUserDetails implements IManageTenantBase {
	public readonly id: ManageTenantIdentifierEnum = ManageTenantIdentifierEnum.ADMIN_CONSOLE_USER_DETAIL_PAGE_USER_ID_ACTION_TO_USER_DETAILS;

	constructor(
		public data: {
			userId: string
		},
		public realm: RealmEnum,
		public tenantId: string
	) {
		this.data = data;
		this.realm = realm;
		this.tenantId = tenantId;
	}
}

export class ManageTenantTenantDetailPage implements IManageTenantBase {
	public readonly id: ManageTenantIdentifierEnum = ManageTenantIdentifierEnum.TENANT_DETAIL_PAGE;

	constructor(
		public realm: RealmEnum,
		public tenantId: string
	) {
		this.realm = realm;
		this.tenantId = tenantId;
	}
}

export class ManageTenantTenantListPage implements IManageTenantBase {
	public readonly id: ManageTenantIdentifierEnum = ManageTenantIdentifierEnum.TENANT_LIST_PAGE;

	constructor(
		public realm: RealmEnum,
		public tenantId: string
	) {
		this.realm = realm;
		this.tenantId = tenantId;
	}
}
